
export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home" 
      className="relative pt-24 pb-20 overflow-hidden"
      style={{
        backgroundImage: 'url(https://public.readdy.ai/ai/img_res/99712cc35623e21a7ae44bf53a490432.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-blue-900/95 via-blue-800/90 to-transparent"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          <div className="flex-1 text-white w-full">
            <h1 className="text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              Secure Your Digital Life with Advanced VPN Technology
            </h1>
            <p className="text-xl mb-8 text-blue-100 leading-relaxed">
              SIERRA ROJA S.R.L. delivers cutting-edge VPN solutions to protect your online privacy and security. Experience fast, reliable, and encrypted connections wherever you go.
            </p>
            <div className="flex flex-wrap gap-4">
              <button 
                onClick={scrollToContact}
                className="px-8 py-4 bg-white text-blue-600 rounded-lg font-semibold hover:bg-blue-50 transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
              >
                Get Started
              </button>
              <button 
                onClick={() => document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' })}
                className="px-8 py-4 bg-transparent border-2 border-white text-white rounded-lg font-semibold hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap"
              >
                Learn More
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent"></div>
    </section>
  );
}
